import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=365c1c86"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=365c1c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports